import dayjs from 'dayjs'

const enShortLocale = {
  name: 'en-short',
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '1s',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy',
  },
}

const plShortLocale = {
  name: 'pl-short',
  relativeTime: {
    future: 'za %s',
    past: '%s',
    s: '1s',
    m: '1m',
    mm: '%dm',
    h: '1godz',
    hh: '%dgodz',
    d: '1d',
    dd: '%dd',
    M: '1mies',
    MM: '%dmies',
    y: '1r',
    yy: '%dr',
  },
}

export function registerShortLocales() {
  dayjs.locale(enShortLocale.name, enShortLocale, false)
  dayjs.locale(plShortLocale.name, plShortLocale, false)
}
